import { Link } from 'react-router-dom'

export function Footer() {
  return (
    <footer className="border-t border-border mt-auto">
      <div className="container mx-auto flex flex-col items-center gap-4 px-4 py-6 md:flex-row md:justify-between">
        <p className="text-sm text-muted-foreground">
          © {new Date().getFullYear()} Badminton Leagues
        </p>
        <nav className="flex gap-4">
          <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Privacy
          </Link>
          <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Terms
          </Link>
        </nav>
      </div>
    </footer>
  )
}
